module.exports = __webpack_public_path__ + "img/ionic-ios-pin.1174086f.svg";